import { PipeTransform, Pipe } from '@angular/core';

@Pipe({name: 'values'})
export class ValuesPipe implements PipeTransform {
	transform(obj: any, args:string[]) : any {
		return Object.values(obj);
	}
}